export default __webpack_public_path__ + "media/images/user_photos/152-36f22e0319834fb9cdba4f5887596472.jpg";